var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_9935)",
    filter: "url(#filter0_d_2537_9935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5861 45.6432L41.3223 48L37.2088 42.7624L33.0249 47.7606L33 47.7845L32.9751 47.7606L21.1492 33.6328C22.9947 32.1796 25.1358 31.0588 27.4728 30.3659L23.3588 25.1277C21.0681 26.0369 18.9474 27.2603 17.0553 28.7419L12.9614 23.8512C14.9043 22.3348 17.0378 21.0343 19.322 19.9878L15.3212 14.8936C13.0235 16.0418 10.8625 17.4069 8.86759 18.9604L4 13.1453C4.04221 13.1147 4.09862 13.0729 4.16899 13.0207C4.90553 12.4746 7.1704 10.7953 10.694 9.00208L5.47494 2.35677L8.73876 0L14.4553 7.27866L14.4594 7.27697L19.1387 13.2349L19.1345 13.2365L23.2577 18.4865L23.2621 18.4852L27.4958 23.8757L27.4911 23.8767L31.9823 29.5952L31.9875 29.5949L39.8504 39.6065L39.8476 39.6099L44.5861 45.6432ZM42.2641 36.723L44.8508 33.6328C42.6006 31.8609 39.911 30.5832 36.9626 29.9728L42.2641 36.723ZM31.7436 23.3277C32.1598 23.3081 32.5787 23.2982 33 23.2982C39.0481 23.2982 44.5991 25.3391 48.9447 28.7419L53.0386 23.8512C47.5723 19.5849 40.5976 17.0273 33 17.0273C31.017 17.0273 29.0765 17.2015 27.1941 17.5349L31.7436 23.3277ZM22.8865 12.0501C26.1083 11.2067 29.4993 10.7564 33 10.7564C42.1471 10.7564 50.5454 13.8307 57.1324 18.9604L62 13.1453C61.9587 13.1154 61.9033 13.0743 61.835 13.0238C60.0461 11.6987 49.0992 3.58967 33 3.58967C27.3321 3.58967 22.3066 4.59176 18.0947 5.94896L22.8865 12.0501ZM59.0818 32.0103C58.1879 31.6701 57.1363 31.5 55.9269 31.5C54.7175 31.5 53.6659 31.6782 52.7721 32.0346C51.8782 32.391 51.1508 32.8851 50.5899 33.5169C50.0291 34.1487 49.6523 34.8859 49.4595 35.7283L52.0622 36.8218C52.1849 35.866 52.5705 35.1208 53.219 34.5862C53.8675 34.0515 54.7088 33.7842 55.7429 33.7842C56.479 33.7842 57.0837 33.8814 57.5569 34.0758C58.0477 34.2541 58.407 34.5295 58.6348 34.9021C58.8802 35.2585 59.0029 35.6878 59.0029 36.19C59.0029 36.7084 58.8627 37.1539 58.5822 37.5265C58.3018 37.8829 57.8198 38.1826 57.1363 38.4256C56.4527 38.6686 55.4887 38.863 54.2443 39.0088V42.6782H56.9522L57.0311 40.2239C57.9425 40.1267 58.775 39.9242 59.5287 39.6163C60.2824 39.2923 60.8783 38.8225 61.3164 38.2069C61.7721 37.5751 62 36.7813 62 35.8255C62 34.9021 61.7371 34.1244 61.2113 33.4926C60.703 32.8446 59.9932 32.3505 59.0818 32.0103ZM57.0048 45.0596C56.6543 44.7356 56.181 44.5736 55.5851 44.5736C55.0067 44.5736 54.5335 44.7356 54.1654 45.0596C53.8149 45.3675 53.6396 45.7806 53.6396 46.299C53.6396 46.8174 53.8149 47.2305 54.1654 47.5383C54.5335 47.8461 55.0067 48 55.5851 48C56.181 48 56.6543 47.8461 57.0048 47.5383C57.3729 47.2305 57.5569 46.8174 57.5569 46.299C57.5569 45.7806 57.3729 45.3675 57.0048 45.0596Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2537_9935",
    x: 0,
    y: 0,
    width: 66,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2537_9935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2537_9935",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_9935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 48,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.376ca3d411fc38c3070115d8cd327580.svg";
export { ForwardRef as ReactComponent };